import enLang from './entries/en-US';
import srLang from './entries/sr-RS';
import {addLocaleData} from 'react-intl';

const AppLocale = {
  sr: srLang,
  en: enLang
};
addLocaleData(AppLocale.sr.data);
addLocaleData (AppLocale.en.data);

export default AppLocale;



// WEBPACK FOOTER //
// ./lngProvider/index.js